/* Ideal peaking filters, RBJ Audio EQ Cookbook. Educational, not a circuit fit. */
(function (root) {
  'use strict';
  const bands = [
    { name: 'LOW', french: 'Graves', min: 33, max: 330, color: '#65d5e7' },
    { name: 'MID', french: 'Médiums', min: 250, max: 2500, color: '#f7cb70' },
    { name: 'HIGH', french: 'Aigus', min: 1100, max: 11000, color: '#c7a5ff' }
  ];
  const clamp = (v, lo, hi) => Math.min(hi, Math.max(lo, v));
  const frequency = (i, position) => bands[i].min * (bands[i].max / bands[i].min) ** clamp(position, 0, 1);
  const position = (i, hz) => clamp(Math.log(hz / bands[i].min) / Math.log(bands[i].max / bands[i].min), 0, 1);
  // The physical bandwidth knob widens clockwise: mathematical Q decreases.
  const q = width => 8 * (0.4 / 8) ** clamp(width, 0, 1);
  function coefficients(f0, gain, quality, fs = 48000) {
    const A = 10 ** (gain / 40), w = 2 * Math.PI * f0 / fs;
    const alpha = Math.sin(w) / (2 * quality), cos = Math.cos(w), a0 = 1 + alpha / A;
    return { b: [(1 + alpha * A) / a0, -2 * cos / a0, (1 - alpha * A) / a0],
      a: [1, -2 * cos / a0, (1 - alpha / A) / a0] };
  }
  function response(coeff, hz, fs = 48000) {
    const w = 2 * Math.PI * hz / fs, cs = Math.cos(w), sn = Math.sin(w), c2 = Math.cos(2 * w), s2 = Math.sin(2 * w);
    const [b0,b1,b2] = coeff.b, [,a1,a2] = coeff.a;
    const nr = b0 + b1*cs + b2*c2, ni = -b1*sn - b2*s2;
    const dr = 1 + a1*cs + a2*c2, di = -a1*sn - a2*s2;
    return 10 * Math.log10(Math.max(1e-30, (nr*nr + ni*ni) / (dr*dr + di*di)));
  }
  const neutral = () => ({ bands: bands.map((_,i)=>({ freq: frequency(i,.5), gain: 0, width: .5 })), level: 0, bypass: false });
  function validate(value) {
    if (!value || !Array.isArray(value.bands) || value.bands.length !== 3) throw Error('Trois bandes sont requises.');
    const result = neutral();
    value.bands.forEach((b,i)=>{
      if (!b || !['freq','gain','width'].every(k => typeof b[k] === 'number' && Number.isFinite(b[k]))) throw Error('Réglages invalides.');
      result.bands[i] = { freq: clamp(b.freq,bands[i].min,bands[i].max), gain: clamp(b.gain,-12,12), width: clamp(b.width,0,1) };
    });
    if (typeof value.level !== 'number' || !Number.isFinite(value.level)) throw Error('Niveau invalide.');
    result.level=clamp(value.level,-12,12); result.bypass=value.bypass===true; return result;
  }
  const api={bands,clamp,frequency,position,q,coefficients,response,neutral,validate};
  if (typeof module!=='undefined' && module.exports) module.exports=api;
  else root.PEQ=api;
})(typeof window!=='undefined'?window:this);
